import { ref } from 'vue'

export const systemLoading = ref()
export const systemLoadingOpaque = ref(false)
